const styleRadiusBoxValue = '16px';

export const getRadiusStyleBoxValue = (onlyBottom?: boolean) =>
  onlyBottom ? `0 0 ${styleRadiusBoxValue} ${styleRadiusBoxValue}` : styleRadiusBoxValue;
